<template>
    <div class="modal fade" id="popUpNuovaRevisione" role="dialog" data-bs-backdrop="static">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header bg-secondary text-white border-0 p-2">
                    <h6 class="modal-title">
                        <i class="ph-git-branch me-2"></i>Nuova Revisione
                    </h6>
                    <button type="button"
                        class="btn btn-light btn-sm btn-icon border-transparent rounded-pill"
                        data-bs-dismiss="modal">
                        <i class="ph-x icon-x-size"></i>
                    </button>
                </div>
                <div class="modal-body p-3">
                    <textarea
                        v-model="noteNuovaRevisione"
                        class="form-control form-control-sm"
                        rows="4"
                        placeholder="Note revisione (opzionale)">
                    </textarea>
                </div>
                <div class="modal-footer bg-light p-2">
                    <button v-if="$root.hasFunzionalita('REVISIONE_CREATE')" type="button" class="btn btn-secondary btn-sm" @click="confermaRevisione()">
                        <i class="ph-check me-1"></i>Avanti
                    </button>
                    <button type="button" class="btn btn-link btn-sm" data-bs-dismiss="modal">
                        <i class="fal fa-sign-out-alt fa-fw me-2"></i>Annulla
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalNuovaRevisione',

    emits: ['revisione-creata'],

    props: {
        fkIdProgetto: {
            type: Number,
            required: true,
        },
        progressivoCorrente: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            filters: global.filters,
            noteNuovaRevisione: '',
        };
    },

    methods: {
        apri() {
            this.noteNuovaRevisione = '';
            this.filters.openPopUp('popUpNuovaRevisione');
        },

        confermaRevisione() {
            this.filters.closePopUp('popUpNuovaRevisione');
            setTimeout(() => {
                utils.alert.confirm(
                    'ATTENZIONE: la revisione corrente verrà congelata e non sarà più modificabile. Confermi?',
                    () => {
                        utils.post('theb/revisione/insert', {
                            ID_BUDGET: this.fkIdProgetto,
                            PROGRESSIVO: this.progressivoCorrente,
                            NOTE: this.noteNuovaRevisione,
                        }, (response) => {
                            if (response.esito == 0) {
                                utils.alert.success('Nuova revisione creata!');
                                this.$emit('revisione-creata');
                            }
                        });
                    },
                    this.$root
                );
            }, 400);
        },
    },
};
</script>
